import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Link } from '@mui/material';

// project imports
import { DASHBOARD_PATH } from '../../../MuiTheme/themeConfig';
import Logo from '../../../../components/berry/ui-component/Logo';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = ({ short = false }) => (
        <Logo short={short} />
);

export default LogoSection;
